import TagManager from 'react-gtm-module';

export enum AlbyEventName {
  THREAD_CREATED = 'alby_threadCreated',
  MENU_CLICKED = 'alby_menu_clicked',
  FLOATING_CLICKED = 'alby_floating_click',
}

interface AlbyEventData {
  path: string;
  eventName: AlbyEventName;
}

const trackAlbyEvent = ({ path, eventName }: AlbyEventData) => {
  TagManager.dataLayer({ dataLayer: { ecommerce: null } });

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: eventName,
      page: {
        path: path,
      },
    },
  });
};

export default trackAlbyEvent;
